import { useStyles } from '@signavio/ui';
import { jsx as _jsx } from "react/jsx-runtime";
function ConfirmCode({
  children
}) {
  const styles = useStyles(confirmCodeStyles, {});
  return /*#__PURE__*/_jsx("code", {
    ...styles,
    children: children
  });
}
const confirmCodeStyles = ({
  color,
  spacing
}) => ({
  whiteSpace: 'pre-wrap',
  // preserves white space and wraps long string
  wordWrap: 'break-word',
  paddingLeft: spacing.xxsmall,
  paddingRight: spacing.xxsmall,
  paddingBottom: spacing.xxxsmall,
  paddingTop: spacing.xxxsmall,
  backgroundColor: color.active.danger,
  borderBottom: `2px solid ${color.danger.base}`
});
export default ConfirmCode;